import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ForgotPassword } from '@classes/user/userAdd';
import { faSitemap } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@services/auth/auth.service';
import { UiService } from '@services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { UserService } from '@services/user/user.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent
  extends SubscriptionBaseComponent
  implements OnInit
{
  faSitemap = faSitemap;

  ForgotFormForm: UntypedFormGroup;
  isLoading: boolean;

  constructor(
    private authSrv: AuthService,
    private uiSrv: UiService,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.initForm();
    this.initSubscriptions();
  }

  onSubmit(): void {
    this.isLoading = true;
    const newUser: ForgotPassword = {
      username: this.f.username.value,
    };

    this.authService.requestPasswordInit(newUser).subscribe(() => {
      this.isLoading = false;
      this.uiSrv.showSnackbar('Mail sent for the password request.');
      this.router.navigate(['/login']);
    });
  }

  private initForm(): void {
    this.ForgotFormForm = this.formBuilder.group({
      username: ['', Validators.required],
    });
  }

  get f() {
    return this.ForgotFormForm.controls;
  }

  private initSubscriptions(): void {
    this.isLoading = false;

    this.subscription.add(
      this.uiSrv.loadingStateChanged.subscribe((loadingState) => {
        this.isLoading = loadingState;
      })
    );
  }
}
